import React from 'react';

const newsItems = [
  {
    date: '27 novembre 2025',
    title: 'Nuova funzione: contatore esterno degli ascoltatori online',
    paragraphs: [
      'Abbiamo aggiunto una nuova possibilità per le stazioni radio: un contatore esterno degli ascoltatori online che puoi incorporare in qualsiasi sito, widget o player.',
      'Il collegamento è semplicissimo: nel cabinet, nella pagina Live Service, fai clic sul pulsante «Ottieni contatore esterno» e il sistema invierà automaticamente alla tua e-mail un link personale per l’integrazione.',
      'Il contatore si adatta a qualsiasi design perché restituisce solo il valore numerico degli ascoltatori, mentre la parte visiva resta interamente dalla tua parte.',
      'La funzione è già disponibile per tutti gli utenti.'
    ]
  },
  {
    date: '24 novembre 2025',
    title: 'TOP: servizio rinnovato dei ranking musicali per le radio',
    paragraphs: [
      'Abbiamo aggiornato il servizio dei ranking musicali — ora si chiama TOP.',
      'Cosa è cambiato e migliorato:',
      'Solo brani musicali. TOP conta esclusivamente i pezzi reali andati in onda, così le statistiche rispecchiano al massimo la rotazione musicale.',
      'Classifica a dimensione flessibile. Ogni radio può scegliere il ranking che preferisce: TOP-10, TOP-20, TOP-40, TOP-50, TOP-100 — o qualsiasi altro valore in questo intervallo. È comodo sia per la programmazione interna sia per i report verso i detentori dei diritti e gli inserzionisti.',
      "Export coerenti con il TOP-N scelto. La dimensione selezionata del ranking si applica automaticamente anche all'esportazione: puoi scaricare PDF o Excel con lo stesso TOP-N mostrato a schermo.",
      'TOP è già disponibile nel cabinet della radio — basta scegliere il mese, impostare la dimensione desiderata e generare il report.',
      'Per usare TOP è necessaria l’esportazione delle playlist della stazione.'
    ]
  },
  {
    date: '20 novembre 2025',
    title: 'Nuova metrica in Radiomonitor: Average Daily Reach (ADR)',
    paragraphs: [
      'Abbiamo aggiunto in Radiomonitor una nuova metrica — Average Daily Reach (ADR), che mostra quanti ascoltatori unici arrivano sulla tua stazione nel periodo selezionato (1 giorno, 7 giorni, 1 mese, ecc.).',
      'ADR aiuta a vedere la reale copertura della stazione nel periodo scelto, capire quanti ascoltatori coinvolgi davvero e parlare con inserzionisti e partner mostrando un numero di reach chiaro e credibile.',
      'La metrica ADR è utile ai proprietari di radio, ai direttori commerciali, ai direttori di palinsesto e ai marketer che gestiscono campagne pubblicitarie e la crescita della stazione.'
    ]
  },
  {
    date: '17 ottobre 2025',
    title: 'Nuovo servizio AHA — profilo medio di ascolto',
    paragraphs: [
      'Abbiamo aggiunto il servizio AHA (profilo medio di ascolto per giorno della settimana). Mostra come varia l’audience media della stazione durante la giornata in base al giorno.',
      'Per ciascun giorno (dal lunedì alla domenica) il sistema calcola la media oraria, aggregando tutte le giornate corrispondenti nel periodo selezionato.',
      'Il modulo genera sia un grafico sia una tabella a mappa di calore.'
    ]
  },
  {
    date: '16 ottobre 2025',
    title: 'Aggiornata la metodologia di “Carichi di picco”',
    paragraphs: [
      'È stata rivista la metodologia di calcolo del servizio “Carichi di picco” (sezione Statistiche).',
      'Nei periodi “settimana” e “mese” i grafici ora mostrano il reale valore di connessioni simultanee al picco.'
    ]
  },
  {
    date: '15 febbraio 2025',
    title: 'Nuova versione del cruscotto statistiche',
    paragraphs: [
      'Abbiamo ricostruito da zero la sezione “Cabinet utente”. Le metriche principali sono raggruppate per argomento e si caricano più rapidamente grazie a query API ottimizzate.',
      'L’interfaccia è ora comoda anche su tablet, così il team può seguire gli indicatori in tempo reale ovunque si trovi.'
    ]
  },
  {
    date: '28 gennaio 2025',
    title: 'Monitoraggio del silenzio più preciso',
    paragraphs: [
      'Ogni stream dispone della calibrazione automatica del livello audio. Il sistema analizza i dati storici e adatta le soglie dei trigger senza interventi manuali.',
      'È disponibile un nuovo report con marker che mostra orario, durata e origine di ciascun evento per un’analisi più rapida.'
    ]
  },
  {
    date: '10 dicembre 2024',
    title: 'Beta delle notifiche push',
    paragraphs: [
      'Le notifiche push nel browser sono ora in beta per eventi statistici e relativi agli stream. Attivale nel cabinet per iniziare a ricevere avvisi.',
      'Il tuo feedback è prezioso: scrivici a support@radiomonitor.net.'
    ]
  }
];

export default function NewsPageIt({ onSubscribeClick }) {
  return (
    <div
      style={{
        maxWidth: 880,
        margin: '0 auto',
        padding: '40px 24px 80px',
        lineHeight: 1.6,
        color: '#1b1b1f'
      }}
    >
      <h1 style={{ marginBottom: 24, color: '#006e45' }}>Novità di Radiomonitor.net</h1>
      <div
        style={{
          marginBottom: 32,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 16
        }}
      >
        <p style={{ margin: 0, flex: '1 1 320px', lineHeight: 1.6 }}>
          In questa sezione raccogliamo gli aggiornamenti della piattaforma, i miglioramenti ai servizi e i progetti su cui stiamo lavorando.
        </p>
        <button
          type="button"
          onClick={() => onSubscribeClick?.()}
          style={{
            padding: '12px 20px',
            borderRadius: 12,
            border: 'none',
            background: '#006e45',
            color: '#fff',
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
            flex: '0 0 auto'
          }}
        >
          Iscriviti alle novità
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
        {newsItems.map((item) => (
          <article key={item.title}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#4a7f6b', textTransform: 'uppercase' }}>
              {item.date}
            </div>
            <h2 style={{ margin: '8px 0 16px', color: '#134b37', fontSize: 24 }}>
              {item.title}
            </h2>
            {item.paragraphs.map((text, idx) => (
              <p key={idx} style={{ marginBottom: 16 }}>
                {text}
              </p>
            ))}
          </article>
        ))}
      </div>
    </div>
  );
}
